import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


import content from '../content';
import useWindowPosition from '../hook/useWindowPosition';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';

export default function Contact() {
  const animated = useWindowPosition('header', 0.6, 4);
  return (
    <div
      className=" min-h-screen  flex justify-center items-center  "
      id="mycontact"
    >
      <div
        style={{
          minHeight: '50vh',
          background: '#091C29',
        }}
        className="w-full md:w-4/5 md:rounded-xl shadow-2xl flex md:flex-row flex-col-reverse justify-around items-center"
      >
        <LazyLoadImage
          
          src={content.contact.img}
          placeholderSrc={content.contact.imgPlaceholder}
          alt="profile"
          width="250px"
          className=" items-center"
        />
        <div className="font-dosis w-4/5 md:w-2/5 mb-8 transtion duration-2000">
          <h1
            className={`${
              animated ? '' : 'translate-y-10 opacity-0'
            } transform transition duration-1000 text-white text-5xl font-bold`}
          >
            {content.contact.title}
          </h1>
          <br/>
          <p
            className={`${
              animated ? '' : 'translate-y-10 opacity-0'
            } transform transition duration-1000 text-white text-2xl`}
          >
            {content.contact.desc}
            
            
          </p>
          <br/>
         
          <p className={`${
              animated ? '' : 'translate-y-10 opacity-0'
            } transform transition duration-1000 text-white text-2xl`}>
            

            <a className="mr-2"><FontAwesomeIcon icon={faEnvelope}/></a>{content.contact.desc2}</p>
            
         <br/>
          <a href="https://www.linkedin.com/in/alan-boronat" target="_blank" rel="noopener noreferrer">    
          <p className={`${
              animated ? '' : 'translate-y-10 opacity-0'
            } transform transition duration-1000 text-white text-2xl`}>
              <a className="mr-2"><FontAwesomeIcon icon={faLinkedin}/></a>{content.contact.desc3}</p>
          </a>

          {/* <div
            className={`flex ${
              animated ? '' : 'translate-y-10 opacity-0'
            } transform transition duration-3000 `}
          >
            
            {content.contact.socials.map((social, index) => {
              return (
                <LazyLoadImage
                  className="mr-5 mt-4 mb-5"
                  width="75px"
                  key={index}
                  src={social.img}
                  alt={social.alt}
                />
              );
            })}
          </div> */}
        </div>
      </div>
    </div>
  );
}
